module.exports = "/virtual-football/img/virtualf-video.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/virtualf-video.png
// module id = 1986
// module chunks = 6